import { BlockedActionMode } from '_lib/auth/rbac';
import { useLocalization } from '@fluent/react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@material-ui/core';
import React from 'react';

import { AlertIcon } from '../../../../icons';
import { RoleGuard } from '../../../../items/RoleGuard';
import styles from '../styles';

interface SubmitModalProps {
  open: boolean;
  onConfirm: () => void;
  onNavigateToSettings: () => void;
  canSubmit: boolean;
  blockedActionMode: BlockedActionMode;
  blockedMessage: string;
}

const SubmitModal: React.FC<SubmitModalProps> = ({
  open,
  onConfirm,
  onNavigateToSettings,
  canSubmit,
  blockedActionMode,
  blockedMessage,
}) => {
  const { l10n } = useLocalization();
  const classes = styles();

  return (
    <Dialog open={open} aria-labelledby="form-dialog-title">
      <Box className={classes.titleBox}>
        <AlertIcon />
        <DialogTitle id="form-dialog-title">
          {l10n.getString('forms-ivim-modal-submit-warning-title')}
        </DialogTitle>
      </Box>
      <DialogContent>
        <DialogContentText>
          {l10n.getString('forms-ivim-modal-submit-warning-text')}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onNavigateToSettings} color="secondary">
          {l10n.getString('forms-ivim-modal-submit-warning-btn-settings')}
        </Button>
        <RoleGuard
          allowed={canSubmit}
          blockedActionMode={blockedActionMode}
          blockedMessage={blockedMessage}
        >
          <Button onClick={onConfirm} color="primary">
            {l10n.getString('forms-ivim-modal-submit-warning-btn-submit')}
          </Button>
        </RoleGuard>
      </DialogActions>
    </Dialog>
  );
};

export default SubmitModal;
